// extracted by mini-css-extract-plugin
module.exports = {"container":"DataSection_container__1zLnc","title":"DataSection_title__1g0mC","content":"DataSection_content__1zQnn","footer":"DataSection_footer__jPqOx"};